module.exports = __webpack_public_path__ + "static/img_11-48fdc168685304ba0e63a7d871eb8f02.png";